import React, { FC, useContext } from 'react';
import { AlertPanelWrapper } from './AlertPanel.styles';
import { SearchContext } from '../SearchContext';
import { SectionThatDisappearsWhenNoSideBar } from '../Layout/Layout.styles';
import { EditSavedSearchBanner } from '../banners/EditSavedSearchBanner';
import { useIsLoggedIn } from 'shared/hooks/useIsLoggedIn';
import { isShowEditSavedSearchBanner } from '../helpers';
import AlertPanelSimple from './AlertPanelSimple';
import AlertPanelAjax from './AlertPanelAjax';
import { AlertPanelProps } from './AlertPanel.types';

const AlertContent: FC<AlertPanelProps> = ({
    links,
    onSimpleLinkClick,
    onAjaxLinkClick
}) => {
    const { state } = useContext(SearchContext);
    const isLoggedIn = useIsLoggedIn();

    const {
        userAlertId,
        savedSearchAndAlerts,
        previousSavedSearchUri,
        isEditSavedSearchBannerVisible
    } = state;

    const isSavedSearch = userAlertId !== null;
    const showEditSavedSearchBanner = isShowEditSavedSearchBanner(
        userAlertId,
        previousSavedSearchUri,
        savedSearchAndAlerts?.uri
    );

    return (
        <>
            {isSavedSearch ? (
                isLoggedIn &&
                isEditSavedSearchBannerVisible &&
                showEditSavedSearchBanner ? (
                    <SectionThatDisappearsWhenNoSideBar minWidth="0">
                        <AlertPanelWrapper
                            color="graphic-background-accent"
                            data-testid="edit-saved-search-cta-banner-panel"
                        >
                            <EditSavedSearchBanner />
                        </AlertPanelWrapper>
                    </SectionThatDisappearsWhenNoSideBar>
                ) : (
                    <AlertPanelSimple onSimpleLinkClick={onSimpleLinkClick} />
                )
            ) : null}

            <AlertPanelAjax
                links={links}
                onAjaxLinkClick={onAjaxLinkClick}
                onSimpleLinkClick={onSimpleLinkClick}
            />
        </>
    );
};

export default AlertContent;
